import { must } from '@/lib/dom';
import { ICON } from '@/lib/icons';
import { state, save } from '@/store/state';
import { setKioskFit, applyFit, reloadAll } from './grid';
import * as bus from '@/lib/bus';

const IDLE = 2500;
let idleT: number | undefined;
let bar: HTMLElement;

export function initKiosk(): void {
  bar = must('#kioskBar');
  buildBar();
  document.addEventListener('fullscreenchange', onFsChange);
}

export function toggleFullscreen(): void {
  const app = must('#app');
  if (!document.fullscreenElement) void app.requestFullscreen?.();
  else void document.exitFullscreen?.();
}

function onFsChange(): void {
  const on = !!document.fullscreenElement;
  must('#app').classList.toggle('kiosk', on);
  bus.emit('controls:sync', undefined);
  if (on) { setKioskFit(true); arm(); }
  else { setKioskFit(false); stop(); bar.classList.remove('hide'); }
}

function buildBar(): void {
  bar.innerHTML = '';
  const mk = (icon: string, title: string, fn: () => void): HTMLButtonElement => {
    const b = document.createElement('button');
    b.className = 'ico';
    b.title = title;
    b.innerHTML = icon;
    b.addEventListener('click', (e) => { e.stopPropagation(); fn(); });
    return b;
  };
  bar.append(
    mk(ICON.gutter, 'ช่องไฟ', () => {
      state.gutter = state.gutter === 'comfy' ? 'dense' : 'comfy';
      document.documentElement.style.setProperty('--gap', state.gutter === 'comfy' ? '8px' : '6px');
      applyFit();
      save();
      bus.emit('controls:sync', undefined);
    }),
    mk(ICON.reload, 'รีเฟรชสตรีม', () => reloadAll()),
    mk(ICON.fsExit, 'ออกเต็มจอ', () => toggleFullscreen()),
  );
}

function showBar(): void {
  bar.classList.remove('hide');
  must('#app').classList.remove('hidecursor');
  clearTimeout(idleT);
  idleT = window.setTimeout(() => {
    bar.classList.add('hide');
    must('#app').classList.add('hidecursor');
  }, IDLE);
}

const activity = (): void => { if (document.fullscreenElement) showBar(); };

function arm(): void {
  for (const e of ['pointermove', 'pointerdown', 'keydown', 'touchstart']) window.addEventListener(e, activity, { passive: true });
  showBar();
}

function stop(): void {
  clearTimeout(idleT);
  for (const e of ['pointermove', 'pointerdown', 'keydown', 'touchstart']) window.removeEventListener(e, activity);
  must('#app').classList.remove('hidecursor');
}
